<script>
import { GET_UPCOMING_ORDERS_QUERY } from '@/graph/gql/user.gql'

// return orders.reduce((acc, order) => {
//   order.lineItems.forEach(x => {
//     const accumulatedQuanity = this.lodash.get(
//       acc,
//       [x.product.id, 'quantity'],
//       0
//     )

//     acc[x.product.id] = {
//       quantity: accumulatedQuanity + x.quantity,
//       ...x.product
//     }
//   })

//   return acc
// }, {})

export default {
  name: 'UpcomingOrdersView',
  apollo: {
    orders: {
      query: GET_UPCOMING_ORDERS_QUERY,
      update: data => data.upcomingOrders
    }
  },
  data() {
    return { orders: [], daySelected: 0 }
  },
  computed: {
    // Get the next 7 days of the week
    daysList() {
      const today = this.$moment().day()
      return this.lodash.times(7, n => this.$moment().day(today + n))
    },

    // Get products sorted by orders for next 7 days of the week
    pickups() {
      if (!this.orders) return []
      const { values } = this.lodash

      return this.daysList.map(day => {
        // Filter orders for same day
        const orders = this.ordersForSameTime(day, 'day')

        const pickups = this.groupOrdersByTime(orders)
        return values(pickups).sort((a, b) => a.time.diff(b.time))
      })
    }
  },
  methods: {
    ordersForSameTime(date, period, orders = this.orders) {
      return orders.filter(x => this.$moment(x.deliverOn).isSame(date, period))
    },

    groupOrdersByTime(orders) {
      const { get } = this.lodash

      return orders.reduce((acc, order) => {
        const { id, deliverOn } = order

        const time = this.$moment(deliverOn).subtract(15, 'minutes')
        const index = time.format('h:mma')

        const items = this.groupOrderItems(
          order.lineItems,
          get(acc, [index, 'items'], {})
        )

        acc[index] = {
          id: id.slice(id.length - 5), // last 5 chars of id
          time,
          items
        }

        return acc
      }, {})
    },

    groupOrderItems(lineItems, prevValue) {
      const { get } = this.lodash

      return lineItems.reduce((acc, item) => {
        const x = get(acc, [item.product.id, 'quantity'], 0)
        acc[item.product.id] = {
          quantity: x + item.quantity,
          ...item.product
        }

        return acc
      }, prevValue)
    }
  }
}
</script>

<template>
  <transition name="slide-up" appear>
    <!-- Upcoming orders page -->
    <div class="view-grid">
      <div>
        <div class="display-1 font-weight-bold mb-3">
          Upcoming pickups
        </div>

        <div class="mb-8 mt-4">
          <div class="day-select">
            <div class="day-options d-flex pl-5 pr-4">
              <v-chip
                :color="daySelected === 0 ? 'primary' : ''"
                :text-color="
                  daySelected !== 0 && pickups[0].length ? 'primary' : ''
                "
                :outlined="daySelected !== 0"
                class="mr-1"
                :ripple="true"
                @click="daySelected = 0"
              >
                <v-icon left>$vuetify.icons.sun</v-icon>
                Today
              </v-chip>
              <v-chip
                :color="daySelected === 1 ? 'primary' : ''"
                :text-color="
                  daySelected !== 1 && pickups[1].length ? 'primary' : ''
                "
                :outlined="daySelected !== 1"
                class="mr-1"
                :ripple="true"
                @click="daySelected = 1"
              >
                Tomorrow
              </v-chip>
              <v-chip
                v-for="(day, i) in daysList.slice(2)"
                :key="i"
                :color="daySelected === i + 2 ? 'primary' : ''"
                :text-color="
                  daySelected !== i + 2 && pickups[i + 2].length
                    ? 'primary'
                    : ''
                "
                :outlined="daySelected !== i + 2"
                class="mr-1"
                :ripple="true"
                @click="daySelected = i + 2"
              >
                {{ day | moment('ddd DD') }}
              </v-chip>
            </div>
          </div>
        </div>

        <div>
          <v-skeleton-loader
            :loading="$apollo.loading"
            transition="fade-transition"
            type="list-item-avatar-two-line"
          >
            <div class="mt-3">
              <!-- Day -->
              <div class="mb-6 body-2">
                <!-- Pickups -->
                <div v-if="!lodash.isEmpty(pickups[daySelected])">
                  <div
                    v-for="pickup in pickups[daySelected]"
                    :key="pickup.id"
                    class="mb-2"
                  >
                    <!-- Pickup time -->
                    <div class="d-flex justify-space-between secondary--text">
                      <div>{{ pickup.time.format('h:mma') }}</div>
                      <div>Order #{{ pickup.id }}</div>
                    </div>
                    <!-- Pickup items -->
                    <div
                      v-for="(item, id) in pickup.items"
                      :key="id"
                      class="d-flex black--text"
                    >
                      <span class="subtitle-2 flex-grow-1">
                        {{ item.name }}
                      </span>
                      <span> {{ item.quantity }}× </span>
                    </div>
                  </div>
                </div>
                <div v-else class="orders-empty pb-2">
                  <div class="subtitle-1 font-weight-bold">
                    No orders on {{ daysList[daySelected].format('ddd DD') }}
                  </div>
                  <div class="body-2">
                    You can relax. We'll message you<br />
                    when you get a new order.
                  </div>
                  <div class="px-5 pt-3 empty-illustration">
                    <v-img src="@/assets/master_delivery.svg" />
                  </div>
                </div>
              </div>
            </div>
          </v-skeleton-loader>
        </div>
      </div>
    </div>
  </transition>
</template>

<style lang="sass" scoped>
h1
  font-size: 28px

.v-btn--outlined
  border-color: #aaa

.day-select
  margin-left: -20px
  overflow-x: auto
  -ms-overflow-style: none
  @media only screen and (max-device-width: 960px)
    width: 100vw
  &::-webkit-scrollbar
    display: none
  .day-options
    width: fit-content
  .v-chip
    font-size: 12px
    flex-shrink: 0
    .v-icon
      font-size: 12px
      &.v-icon--left
        margin-left: -2px
        margin-right: 8px

.empty-illustration
  position: fixed
  bottom: 25px
  right: 0
  width: 80%
  max-width: 500px

.orders-empty
  text-align: center
  margin-top: 30%
</style>
